export default __webpack_public_path__ + "static/media/c2s-logo-white.d7997f7f.png";